module.exports = __webpack_public_path__ + "static/media/login-background.7cc2f64d.png";